module.exports = __webpack_public_path__ + "img/cr.ffa1546f.png";